import Echo from "laravel-echo";
import Pusher from "pusher-js";

let subscribedChannel = null;
let listener = null;

function buildEchoConfig() {
  const token = localStorage.getItem("token");

  return {
    broadcaster: "reverb",
    key: process.env.VUE_APP_REVERB_APP_KEY,
    wsHost: process.env.VUE_APP_REVERB_HOST,
    wsPort: process.env.VUE_APP_REVERB_PORT || 5052,
    wssPort: process.env.VUE_APP_REVERB_PORT || 5052,
    forceTLS: (process.env.VUE_APP_REVERB_SCHEME ?? "http") === "https",
    enabledTransports: ["ws", "wss"],
    authEndpoint: `${process.env.VUE_APP_API_HOST}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    },
  };
}

export function ensureNotificationEcho() {
  window.Pusher = Pusher;

  if (!window.Echo) {
    window.Echo = new Echo(buildEchoConfig());
    return window.Echo;
  }

  const config = buildEchoConfig();
  window.Echo.options.authEndpoint = config.authEndpoint;
  window.Echo.options.auth = config.auth;

  return window.Echo;
}

export function subscribeToAppNotifications(userId, onNotification) {
  if (!userId || typeof onNotification !== "function") {
    return;
  }

  unsubscribeFromAppNotifications();

  const echo = ensureNotificationEcho();

  if (echo.connector?.pusher?.connection) {
    echo.connector.pusher.connection.bind("error", (error) => {
      console.warn("[notifications] websocket connection error", error);
    });
  }

  subscribedChannel = echo.private(`user.${userId}`);
  listener = () => onNotification();
  subscribedChannel
    .listen(".AppNotificationPushed", listener)
    .error((error) => {
      console.warn("[notifications] private channel subscription failed", error);
    });
}

export function unsubscribeFromAppNotifications() {
  if (subscribedChannel && listener) {
    subscribedChannel.stopListening(".AppNotificationPushed", listener);
  }

  subscribedChannel = null;
  listener = null;
}
